export default {
  status: { 1: 'CURRENT', 2: 'REJECTED', 3: 'PENDING', 4: 'EXPIRED', 5: 'FUTURE' },
  freightUnit: { 1: 'Per Trip', 2: 'Per Ton', 3: 'Per KG', 4: 'Per CFT', 5: 'Per Package', 6: 'Per Case', 7: 'Per Box', 8: 'Per KM', 9: 'Percentage' },
  deliveryType: { 1: 'FTL', 2: 'PTL' },
  contractType: {
    1: 'City',
    2: 'State',
    3: 'Region',
    4: 'Point',
    5: 'City-Point',
    6: 'City-State',
    7: 'City-Region',
    8: 'State-Point',
    9: 'State-City',
    10: 'State-Region',
    11: 'Region-Point',
    12: 'Region-City',
    13: 'Region-State',
    14: 'Point-City',
    15: 'Point-State',
    16: 'Point-Region',
    17: 'Pincode-Point',
    18: 'Pincode-City',
    19: 'Pincode-State',
    20: 'Pincode-Region',
    21: 'Point-Pincode',
    22: 'City-Pincode',
    23: 'State-Pincode',
    24: 'Region-Pincode',
    25: 'Pincode',
    26: 'Route',
  },
  movement: { 1: 'Secondary', 2: 'Primary', 3: 'Vendor', 4: 'Return' },
  bdr_configField: [
    { id: 31, title: 'BFR Label', colSpan: 3, column: 'bdr_label', show: false, disabled: false, dataType: 'string' },
    { id: 32, title: 'BFR Charge', colSpan: 2, column: 'bdr_charge', show: false, disabled: true, dataType: 'number' },
  ],
  lastMileFields: [
    { id: 33, title: 'Return Pickup Point Charges', colSpan: 3, column: 'return_pickup_point_charges', show: false, disabled: false, dataType: 'number' },
    { id: 34, title: 'Return Drop Point Charges', colSpan: 3, column: 'return_drop_point_charges', show: false, disabled: false, dataType: 'number' },
    { id: 35, title: 'RTO Charges', colSpan: 3, column: 'rto_charges', show: false, disabled: false, dataType: 'number' },
    { id: 36, title: 'Minimum RTO Charges', colSpan: 3, column: 'minimum_rto_charges', show: false, disabled: false, dataType: 'number' },
  ],
  SLAfields: [
    { id: 37, title: 'SLA Acceptance time (in minutes)', colSpan: 3, column: 'acceptance_sla_breach_time', show: false, disabled: false, dataType: 'number' },
    { id: 38, title: 'SLA Arrival time (in minutes)', colSpan: 3, column: 'arrival_sla_breach_time', show: false, disabled: false, dataType: 'number' },
  ],
};
